
export interface StatDay {
  date: string;
  nbSessions: number;
  elapsedTime: number;
  distance: number;
  createdAt?: number;
}

export enum StatSportType {
  ALL = 'all',
  CYCLING = 'cycling',
  RUNNING = 'running',
  ROWING = 'rowing'
}

export type StatDays = Array<StatDay>;

export interface StatDayFromHttp {
  day: string;
  nb_sessions: number;
  elapsed_time: number;
  total_distance: number;
}

export type StatDaysFromHttp = {
  [key: string]: StatDayFromHttp;
};

export interface TrainingLogByDayFromHttp {
  data: {
    totalSessionsByInterval: number;
    elapsedTimeByInterval: number;
    totalDistanceByInterval: number;
    days?: StatDaysFromHttp
  };
}

export interface TrainingLogByYearFromHttp {
  data: Array<TrainingLogYearHttp>;
}

export type StatYears = Array<TrainingLogYear>;
export interface TrainingLogYear {
  year: number;
  total_sessions_by_year: number;
  elapsed_time_by_year: number;
  total_distance_by_year: number;
  months: Array<TrainingLogMonth>;
}


export interface TrainingLogMonth {
  nb_sessions: number;
  elapsed_time: number;
  total_distance: number;
  month: number;
}

export interface TrainingLogYearHttp extends Omit<TrainingLogYear, 'months'> {
  months: Array<TrainingLogMonthHttp>;
}
export interface TrainingLogMonthHttp extends Omit<TrainingLogMonth, 'month'> {
  month: string;
}
